export const USER_LOGIN_REQUEST = "API/ENTITIES/USER_LOGIN/USER_LOGIN_REQUEST";
export const USER_LOGIN_REQUEST_SUCCESS =
  "API/ENTITIES/USER_LOGIN/USER_LOGIN_REQUEST_SUCCESS";
export const USER_LOGIN_REQUEST_FAILURE =
  "API/ENTITIES/USER_LOGIN/USER_LOGIN_REQUEST_FAILURE";
